import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useAppDispatch } from "src/hooks/redux";
import { clearCustomerRisk } from "src/services/AdminDashService";
import { Applicant } from "src/types/Applicant";
import ErrorIcon from "../Shared/icons/ErrorIcon";

interface RiskApprovalModalProps {
  showModal: boolean;
  applicationId: number | string;
  highRiskApplicants: Applicant[];
  onConfirmApprove: (wasSuccessful: boolean) => void;
  onCancel: () => void;
}

const RiskApprovalModal = ({
  showModal,
  applicationId,
  highRiskApplicants = [],
  onConfirmApprove,
  onCancel,
}: RiskApprovalModalProps) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useAppDispatch();

  const handleApprove = async () => {
    setShowSpinner(true);

    try {
      // Call the service to clear the customer risk
      const wasSuccessful = await dispatch(
        clearCustomerRisk(highRiskApplicants, applicationId)
      );

      onConfirmApprove(wasSuccessful);
    } catch (err) {
      console.error("Failed to approve risk score:", err);
      onConfirmApprove(false);
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      className="risk-approval-modal"
    >
      <Modal.Header className="border-bottom-0" closeButton onHide={onCancel}>
        <Modal.Title
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            lineHeight: "1",
          }}
        >
          <ErrorIcon />
          <span
            style={{
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "1",
              verticalAlign: "middle",
            }}
          >
            Confirm approval
          </span>
        </Modal.Title>
      </Modal.Header>
      <hr style={{ margin: 0, borderTop: "2px solid #DCDDDF" }} />
      <Modal.Body>
        <div className="details block-labels mt-0">
          <p className="mb-3">
            By clicking the approve button below,
            <strong>
              {" "}
              you are confirming that you are aware of the risk score and
              allowing this application to proceed.
            </strong>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0">
        <Button
          className="cancel-btn-high-risk"
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          className="btn-approve"
          onClick={handleApprove}
          disabled={showSpinner}
        >
          {showSpinner && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
          )}
          {showSpinner ? "Approving..." : "  Approve  "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RiskApprovalModal;
